import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {MappedServoData} from "./mappedservoData";
import {UrlBuilder} from "../url-builder/url.builder";


@Injectable({
  providedIn: 'root'
})
export class MappedServoDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<MappedServoData> {
    this.uiUrl = this.url.GetMappedServoUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<MappedServoData>(this.uiUrl);
  }


}

